.container {
    background-color: var(--content-background-color);
    padding-left: var(--main-container-side-padding);
    padding-right: var(--main-container-side-padding);
}
